// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"section-title-icon_titleIcon___O7zS","icon":"section-title-icon_icon__aP1SZ"};